export const pluralize = (count: number, word: string, plural?: string): string => {
  if (count === 1) {
    return word
  }

  if (plural) {
    return plural
  }

  if (word.endsWith('y')) {
    return word.slice(0, -1) + 'ies'
  }

  return word + 's'
}
